import React, { forwardRef } from "react";
import { PRODUCT } from "constants/appConstant";
import InfinityPanel from "./Infinity";
import Axiom from "./Axiom";
import Compass from "./Compass";
import Array from "./Array";
import Console from "./Console";
import Eloquence from "./Eloquence";
import SecurityConsolePanel from "./SecurityConsole";
import HiddenHeadwall from "./Hidden";

const HeadWalls = forwardRef((props, ref) => {
  const { values } = props;
  return (
    <>
      {(() => {
        switch (values.model) {
          case PRODUCT.INFINITY:
            return <InfinityPanel ref={ref} {...props} />;
          case PRODUCT.AXIOM:
            return <Axiom ref={ref} {...props} />;
          case PRODUCT.COMPASS:
            return <Compass ref={ref} {...props} />;
          case PRODUCT.ARRAY:
            return <Array ref={ref} {...props} />;
          case PRODUCT.CONSOLE:
            return <Console ref={ref} {...props} />;
          case PRODUCT.ELOQUENCE:
            return <Eloquence ref={ref} {...props} />;
          case PRODUCT.SECURITY:
            return <SecurityConsolePanel ref={ref} {...props} />;
          case PRODUCT.HIDDEN:
            return <HiddenHeadwall ref={ref} {...props} />;
          default:
            return null;
        }
      })()}
    </>
  );
});

export default HeadWalls;
